<template>
  <div class="column no-padding">
    <div
      :class="{ 'hide-low-display': noteInputExpanded }"
      class="row col-grow"
    >
      <q-scroll-area
        class="full-width"
        :thumb-style="{ width: '5px','background-color': '#555',opacity: 1 }"
      >
        <q-list v-if="hasNotes || preliminaryNote" no-border separator class="q-pa-none text-select">
          <note-item
            v-for="note in notes"
            :key="note.id"
            :note="note"
            :updateNoteMethod="updateNoteMethod"
            :deleteNoteMethod="deleteNoteMethod"
          />

          <note-item
            v-if="preliminaryNote"
            :note="preliminaryNote"
            :updateNoteMethod="updateNoteMethod"
            :deleteNoteMethod="deleteNoteMethod"
            disabled
          />
        </q-list>

        <template v-if="!(hasNotes || preliminaryNote) && !hideEmptyState">
          <div class="row justify-center items-center col-grow q-pt-lg">
            <div class="text-center">
              <img src="~assets/emptystates/notes_empty.svg" height="100px" />

              <h6 class="q-my-md text-faded">{{ $t('no_notes') }}</h6>
            </div>
          </div>
        </template>
      </q-scroll-area>
    </div>

    <div class="q-my-md q-px-lg" v-is-user>
      <expandable-textarea
        v-model="noteText"
        :classes="['block', 'full-width']"
        :placeholder="$t('write_note')"
        @expand="noteInputExpanded = true"
        @collapse="noteInputExpanded = false"
      />

      <div v-show="noteInputExpanded" class="row justify-end q-mt-sm">
        <q-btn flat color="white" text-color="light" @click="handleCancel">{{ $t('cancel') }}</q-btn>

        <q-btn flat color="white" text-color="faded" @click="handleSave">{{ $t('save') }}</q-btn>
      </div>
    </div>
  </div>
</template>

<script>
  import ExpandableTextarea from 'components/Common/Inputs/ExpandableTextarea.vue'
  import NoteItem from './NoteItem'
  import { createErrorFromResponse } from 'src/utils/error'
  import { mapGetters } from 'vuex'

  export default {
    props: {
      notes: {
        type: Array,
        required: true
      },

      createNoteMethod: {
        type: Function,
        required: true
      },

      updateNoteMethod: {
        type: Function,
        required: true
      },

      deleteNoteMethod: {
        type: Function,
        required: true
      },

      hideEmptyState: {
        type: Boolean,
        default: false
      }
    },

    data () {
      return {
        noteText: null,
        noteInputExpanded: false,
        preliminaryNote: null
      }
    },

    computed: {
      ...mapGetters(['user']),

      hasNotes () {
        return this.notes && this.notes.length > 0
      }
    },

    methods: {
      handleCancel () {
        this.noteText = null
      },

      handleSave () {
        this.preliminaryNote = {
          text: this.noteText,
          is_private: false,
          user: { data: this.user },
          created_at: { date: new Date() }
        }

        this.noteText = null

        this.createNoteMethod(this.preliminaryNote)
          .catch(error => {
            this.noteText = this.preliminaryNote.text

            createErrorFromResponse(error)
          })
          .then(() => {
            this.preliminaryNote = null
          })
      }
    },

    components: {
      ExpandableTextarea,
      NoteItem
    }
  }
</script>
